import { imgDomain, appDomain } from '@/jslib/env'
import utils from '@/jslib/utils'
import {clearUserData, getUserBuildingData} from "../api/api"
import store from "../vuex/store"
import Vconsole from "vconsole"
import Vue from "vue"

export default {
  data() {
    return {
      imgDomain,
      backBtnShow: true,
      testConsole: 0
      }
  },
  methods: {

    /**
     * 返回主页面
     */
    backMainActivity() {
      // web
      if(utils.getEnv()==='web') console.log('返回主页面')
      // app
      if(utils.getEnv()==='android') window.android.backMainActivity()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.backMainActivity.postMessage({ })
    },

    /**
     * 返回上一页
     * @param delta 返回页面数量
     */
    navigateBack(delta) {
      if (typeof delta != 'number') delta = 1
      if (~~utils.getQueryString('refresh_times') && delta === 1) delta = ~~utils.getQueryString('refresh_times') + 1

      this.$router.go(-delta)

      /*// web
      if(utils.getEnv()==='web' || store.getters.isFromMyHome){ this.$router.go(-delta); return }
      // app
      if(utils.getEnv()==='android') window.android.finishCurrentActivity(delta)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.finishCurrentActivity.postMessage({ delta })*/
    },

    /**
     * 返回上一页（有标记page_level（进入的第一个页面）就退出）
     * */
    goBack() {
      this.getEntrance() ? this.finishCurrentActivity() : this.navigateBack()
    },

    /**
     * 关闭当前页面
     * @param delta 关闭页面数量
     * */
    finishCurrentActivity(delta){
      if (typeof delta != 'number') delta = 1

      // web
      if(utils.getEnv()==='web' || store.getters.isFromMyHome){ this.$router.go(-delta); return }
      // app
      if(utils.getEnv()==='android') window.android.finishCurrentActivity(delta)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.finishCurrentActivity.postMessage({ delta })
    },

    /**
     * 跳转到新页面
     * @param url 页面路由
     */
    navigateTo(url) {

      this.$router.push(url || '/');

      /*// web
      if(utils.getEnv()==='web' || store.getters.isFromMyHome){ this.$router.push(url || '/'); return }
      // app
      if(utils.getEnv()==='android') window.android.createNewActivity(appDomain + url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.createNewActivity.postMessage({ url: appDomain + url })*/
    },

    /**
     * 跳转到新页面 (APP新层)
     * @param url 页面路由
     * */
    navigateToNewAct(url) {

      // 不在魔方屋app内
      if( !utils.getPlatform().mfhApp || store.getters.isFromMyHome){
        try{
          this.$router ? this.$router.push(url || '/') : location.href = appDomain + url
        }catch (e) {
          console.log('跳转到', url)
        }
        return
      }
      // app
      if(utils.getEnv()==='android') window.android.createNewActivity(appDomain + url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.createNewActivity.postMessage({ url: appDomain + url })
    },

    /**
     * 关闭当前页面跳转到新页面
     * @param url 页面路由
     */
    redirectTo(url) {

      this.$router.replace(url)

      /*if(utils.getEnv()==='web' || store.getters.isFromMyHome){ this.$router.replace(url); return }
      // app
      if(utils.getEnv()==='android') window.android.createNewActivityAndFinishCurrent(appDomain + url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.createNewActivityAndFinishCurrent.postMessage({ url: appDomain + url })*/
    },

    /**
     * 跳转到新页面(全链)
     * @param url 全链接
     */
    createNewActivity(url) {
      // web
      if(utils.getEnv()==='web') window.location.href = url
      // app
      if(utils.getEnv()==='android') window.android.createNewActivity(url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.createNewActivity.postMessage({ url })
    },

    /**
     * To ShapeSpark
     * */
    toShapeSpark(url){
      // web
      if(utils.getEnv()==='web') window.location.href = url
      // app
      if(utils.getEnv()==='android') window.android.toShapeSpark(url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.toShapeSpark.postMessage({ url })
    },

    /**
     * todo: 跳转到柜子方案ShapeSpark页面
     * */
    toClosetShapeSpark(url){
      // web
      if(utils.getEnv()==='web') window.location.href = url
      // app
      if(utils.getEnv()==='android') window.android.toClosetShapeSpark(url)
      // ios
      if(utils.getEnv()==='ios') window.location.href = url       // todo: ios暂时没有开发，这里还是直接跳网页
    },

    /**
     * 跳到Shapespark活动页
     * @param videoUrl 视频链接key
     * @param mShapesparlUrl Shapespar链接
     * @param preBuyUrl 详情页面路由
     * @param caseInfo 方案详情 = {
     *                      title 标题
     *                      desc 介绍
     *                      url 页面路由
     *                      picUrl 头图链接key
     *                   }
     */
    jumpShapesparkActivity(videoUrl, mShapesparlUrl, preBuyUrl, caseInfo) {
      // web
      if(utils.getEnv()==='web'){
        this.$router.push(preBuyUrl)
        console.log('shareInfo: ', caseInfo)
      }
      // app todo 20200810 兼容老版本没有caseInfo参数app1.0.7以下
      if(utils.getEnv()==='android'){
        try{
          window.android.jumpShapesparkActivity(imgDomain+videoUrl,mShapesparlUrl,appDomain + preBuyUrl, JSON.stringify(caseInfo))
        }catch (e){
          window.android.jumpShapesparkActivity(imgDomain+videoUrl,mShapesparlUrl,appDomain + preBuyUrl)
        }
      }
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpShapesparkActivity.postMessage({ videoUrl: imgDomain+videoUrl, mShapesparlUrl, preBuyUrl: appDomain + preBuyUrl, caseInfo })
    },

    /**
     * 回到首页
     * @param url 页面路由
     */
    reLaunchTo(url) {
      // wx.reLaunch({ url })
    },

    /**
     * 分享链接
     * @param title 标题
     * @param desc 介绍
     * @param url 页面路由
     * @param picUrl 头图链接key
     */
    shareURL(title,desc,url,picUrl) {

      url = this.updateUrlQS( url, 'time', Date.now()) // 分享时url加上时间戳, 防止微信浏览器缓存

      // web
      if(utils.getEnv()==='web') console.log('分享网页:',title,desc,appDomain + url,imgDomain+picUrl)
      // app
      if(utils.getEnv()==='android') window.android.shareURL(title,desc,appDomain + url,imgDomain+picUrl)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.shareURL.postMessage({ title,desc,url:appDomain + url,picUrl:imgDomain+picUrl })
    },

    /**
     * 跳转到结算页面
     * @param carId 购物车产品id
     * @param schemeId 方案id
     */
    jumpConfirmOrder(carId, schemeId) {
      // web
      if(utils.getEnv()==='web')  this.navigateTo('orderFilling?cart_id='+carId) // console.log('跳转结算:',carId, schemeId)
      // app
      if(utils.getEnv()==='android') window.android.jumpConfirmOrder(carId, schemeId)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpConfirmOrder.postMessage({ carId, schemeId })
    },

    /**
     * 跳转到二维定制页面
     * @param isDemand 是否定制            (true-用户自己定制的方案  false-官方方案的柜子)
     * @param isCreateScheme 是否重新编辑   (true-创建一个新的方案  false-在原来的方案上修改)
     * @param type 定制间类型
     * @param decorate_product_id 产品id（产品为整配类）
     * @param schemeId 定制方案id
     */
    jump2DDemandOperateActivity(isDemand, isCreateScheme, type, decorate_product_id, schemeId){
      console.log('jump2DDemandOperateActivity')
      // web
      if(utils.getEnv()==='web') console.log('跳转二维定制:',isDemand, isCreateScheme, type, decorate_product_id, schemeId)
      // app
      if(utils.getEnv()==='android') window.android.jump2DDemandOperateActivity(isDemand, isCreateScheme, type, decorate_product_id, schemeId)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jump2DDemandOperateActivity.postMessage({ isDemand, isCreateScheme, type, decorate_product_id, schemeId })
    },

    /**
     * 跳转到BOM清单构件详细信息
     * @param caculateResult BOM清单详情 json字符串
     * @param type 类型 （0=柜体构件｜1=功能组件｜2=五金附件｜3=滑动门明细｜4=收口附件）
     */
    jumpProductDetail(caculateResult, type, price){
      if (!price || price === '0.00') return
      // web
      if(utils.getEnv()==='web') console.log('跳转到BOM清单构件详细信息:', caculateResult, type, price)
      // app
      if(utils.getEnv()==='android') {
        window.android.jumpProductDetail(JSON.stringify(caculateResult), type)
      }
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpProductDetail.postMessage({ caculateResult, type })
    },

    /**
     * 单商品直接购买
     * @param decorate_product_id 产品id
     */
    singleGoodsDirectBuy(decorate_product_id){
      // web
      if(utils.getEnv()==='web') console.log('单商品直接购买')
      // app
      if(utils.getEnv()==='android') window.android.singleGoodsDirectBuy(decorate_product_id)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.singleGoodsDirectBuy.postMessage({ decorate_product_id })
    },

    /**
     * 跳转到当前市楼盘选择
     * */
    jumpToNowHousesList(){
      // web
      if(utils.getEnv()==='web'){
        getUserBuildingData().then((data)=>{
          console.log("用户地址", data.data.data)

          let {last_city} = data.data.data

          if(last_city){
            this.navigateTo('housesList?city=' + last_city)
          } else {
            this.navigateTo('housesList?city=全国')
          }

        }).catch(e => {
          console.log('跳转到楼盘选择页出错', e)
        })
      }
      // app
      if(utils.getEnv()==='android') window.android.jumpToNowHousesList()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToNowHousesList.postMessage({})

    },

    /**
     * 跳转到当前可用户型方案列表
     * */
    jumpToNowHouseCaseList(house_id){
      // web
      if(utils.getEnv()==='web'){
        getUserBuildingData().then(data => {
          console.log("用户地址", data.data.data)

          let {building_data} = data.data.data

          let caseListId = building_data ? 'id='+building_data : 'house_id='+house_id   // 有具体房号用具体房号跳转，没有有时用户型id跳转

          this.navigateTo('HouseCaseList?' + caseListId)

        }).catch(e => {
          console.log('跳转到当前可用户型方案列表出错', e)
        })
      }
      // app
      if(utils.getEnv()==='android') window.android.jumpToNowHouseCaseList()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToNowHouseCaseList.postMessage({})
    },

    /**
     * 跳转到门牌选择
     * */
    jumpToNowAddr(){
      getUserBuildingData().then(data => {
        console.log("用户地址", data.data.data)

        let {building_id} = data.data.data

        if(building_id) this.navigateTo('HouseTypeOption?buildings_id=' + building_id)

      }).catch(e => {
        console.log('跳转到当前可用户型方案列表出错', e)
      })
    },

    /**
     * 拨打号码
     * */
    callNumber(num){
      // web
      if(utils.getEnv()==='web') console.log('拨打号码 ' + num)
      // app
      if(utils.getEnv()==='android') window.android.callNumber(num)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.callNumber.postMessage({num})
    },


    /**
     * 跳转到购物车
     * @param {String} program_id
     * */
    toShoppingCart(program_id){
      let programId = program_id ? '&program_id=' + program_id : ''

      // web
      if(utils.getEnv()==='web') this.navigateTo('houseShoppingCart?isInside=true' + programId)
      // app
      if(utils.getEnv()==='android') window.android.toShoppingCart(program_id)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.toShoppingCart.postMessage(program_id)
    },

    /**
     * 跳转到定位
     * */
    toIndex(){
      // web
      if(utils.getEnv()==='web') this.navigateTo('')
      // app
      if(utils.getEnv()==='android') window.android.toIndex()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.toIndex.postMessage({})
    },


    // --- 活动详情页跳转 ---

    /**
     * 跳转到我的礼物列表
     * */
    jumpToMyGiftsList(){
      // web
      if(utils.getEnv()==='web') console.log('跳转到我的礼物列表')
      // app
      if(utils.getEnv()==='android') try { window.android.jumpToMyGiftsList() }catch (e) { window.android.myGiftsList() }
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToMyGiftsList.postMessage({})
    },

    /**
     *  跳转到某一户型的方案列表页
     */
    jumpToHouseCaseList(house_id){
      this.navigateToNewAct('HouseCaseList?house_id='+house_id+'&page_level=2')
    },

    /**
     *  跳转到某一分类下的商品列表页
     */
    jumpToHouseCaseDetail(program_id){
      this.navigateToNewAct('HouseCaseDetail?program_id='+program_id+'&page_level=2')
    },

    /**
     *  跳转到某一个商品详情页
     *  @param {string} from - 1-易居集市(商城); 2-易家整配; 3-易柜定制
     *  @param {string} id - 商品id
     */
    jumpToHouseGoodsDetail(from, id){
      let productId = 'product_id=' + id
      let decorateProductId= 'decorate_product_id=' + id
      this.navigateToNewAct('HouseGoodsDetail?from=' + from + '&page_level=2&' + ([1, 3].includes(+from) ? productId : decorateProductId))
    },

    /**
     *  进入易柜定制
     */
    jumpToYGDZ(){
      // web
      if(utils.getEnv()==='web') console.log('进入易柜定制')
      // app
      if(utils.getEnv()==='android') window.android.jumpToYGDZ()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToYGDZ.postMessage({})
    },

    /**
     *  进入易居集市
     */
    jumpToYJJS(){
      // web
      if(utils.getEnv()==='web') console.log('进入易居集市')
      // app
      if(utils.getEnv()==='android') window.android.jumpToYJJS()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToYJJS.postMessage({})
    },

    /**
     *  进入易居整配
     */
    jumpToYJZP(){
      // web
      if(utils.getEnv()==='web') console.log('进入易家整配')
      // app
      if(utils.getEnv()==='android') window.android.jumpToYJZP()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToYJZP.postMessage({})
    },

    /**
     *  进入资讯列表页
     */
    jumpInfoListPage(){
      // web
      if(utils.getEnv()==='web') console.log('进入资讯列表页')
      // app
      if(utils.getEnv()==='android') window.android.jumpInfoListPage()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpInfoListPage.postMessage({})
    },

    /**
     * 进入资讯详情页
     * @param title 标题
     * @param image;
     * @param synopsis;
     * @param content;
     * @param look_count;
     * @param create_time;
     * @param news_id;
     */
    jumpInfoDetailPage(news_id){
      // web
      if(utils.getEnv()==='web') console.log('跳转到BOM清单构件详细信息:', news_id)
      // app
      if(utils.getEnv()==='android') window.android.jumpInfoDetailPage(news_id)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpInfoDetailPage.postMessage({ news_id })
    },

    /**
     * 跳转到某一活动关联的商品列表页
     * */
    jumpToActivityProductList(activity_id){
      // web
      if(utils.getEnv()==='web') console.log('跳转到某一活动关联的商品列表页')
      // app
      if(utils.getEnv()==='android') window.android.jumpToActivityProductList(activity_id)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToActivityProductList.postMessage({activity_id: activity_id})
    },

    /**
     * 跳转到某一URL
     * */
    jumpToURL(url){
      // web
      if(utils.getEnv()==='web') location.href = url
      // app
      if(utils.getEnv()==='android') window.android.jumpToURL(url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToURL.postMessage({url: url})
    },

    /**
     * 跳转某一活动详情页
     * @param {String} id 活动id
     * */
    jumpToEventDetail(id){
      // web
      if(utils.getEnv()==='web') this.navigateTo('gift?id='+id)
      // app
      if(utils.getEnv()==='android') window.android.jumpToEventDetail(id)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpToEventDetail.postMessage({id: id})
    },


    // --- 团券活动 ---

    /**
     * 调起APP支付功能
     * @param {Object | JSON} data - 支付信息
     * @param {String} payment - 支付方式
     * @param {String} url - 支付完成后调用的页面 (url传payment_result返回支付后的信息, url传空时刷新当前页面)
     * */
    payFromH5(data, payment, url){
      // web
      if(utils.getEnv()==='web') console.log('支付信息', data, payment, url)
      // app
      if(utils.getEnv()==='android') window.android.payFromH5(JSON.stringify(data), payment, url)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.payFromH5.postMessage({data, payment, url})
    },

    /**
     * 查看我的优惠券
     * @param {Boolean} available - 是否可用优惠券
     * */
    toMyCouponList(available){
      // web
      if(utils.getEnv()==='web') console.log('到我的优惠券列表 是否可用', available)
      // app
      if(utils.getEnv()==='android') window.android.toMyCouponList(available)
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.toMyCouponList.postMessage({available})
    },

    /**
     * 跳转至”我家“
     * */
    toMyHome(){
      // web
      if(utils.getEnv()==='web') this.navigateTo("myHomeInit")
      // app
      if(utils.getEnv()==='android') window.android.toMyHome()
      // ios
      if(utils.getEnv()==='ios') window.webkit.messageHandlers.toMyHome.postMessage({})
    },

    // --- 功能 ---

    /**
     * 放大图片
     * @param picUrl 图片链接
     */
    showBigPic(picUrl) {
      // web
      if (utils.getEnv() === 'web') console.log('放大图片', picUrl)
      // app
      if (utils.getEnv() === 'android') window.android.showBigPic(picUrl)
      // ios
      if (utils.getEnv() === 'ios') window.webkit.messageHandlers.showBigPic.postMessage({ picUrl })
    },

    /**
     * 展示户型图
     * @param {String} title - 户型名称
     * @param {string} pic - 图片url
     * */
    showHousePic(title, pic){
      // web
      if (utils.getEnv() === 'web') throw ErrorEvent// console.log('户型图', {title, pic})
      // app
      if (utils.getEnv() === 'android') window.android.showHousePic(title, pic)
      // ios
      if (utils.getEnv() === 'ios') window.webkit.messageHandlers.showHousePic.postMessage({ title, pic })
    },

    /**
     * 首次进入设置token(登录状态)
     * @param {string} id - 用户id, 默认query.user_id
     * @param {string} token - 用户token, 默认query.user_id
     * */
    setToken(id = this.$route.query.user_id, token = this.$route.query.user_token){

      // 外面直接进入时需要传token
      if(utils.getQueryString('user_token') !== null || token || id){
        utils.setCookie('user_id', id)
        utils.setCookie('user_token', token)
      }

    },

    /**
     * 检查登录
     * */
    checkLogin(){

      if( !utils.getCookie('user_token') ){
        // web
        if(utils.getEnv()==='web'){
          console.log('跳登录')

          // 微信内跳登录
          this.navigateTo('signup?next_url=' + encodeURIComponent(location.pathname.slice(1)+location.search))
        }
        // app
        if(utils.getEnv()==='android') window.android.jumpLogin()
        if(utils.getEnv()==='ios') window.webkit.messageHandlers.jumpLogin.postMessage({})

        return false
      }

      return true
    },

    /**
     * 更新/追加url参数 (update URL QueryString)
     * @Param {String} url - 原url地址
     * @Param {String} key - 参数名
     * @Param {} val - 参数值
     * */
    updateUrlQS(url, key, val) {
      let re = new RegExp("([?&])" + key + "=.*?(&|$)", "i")
      let separator = url.indexOf('?') !== -1 ? "&" : "?"
      return url.match(re) ? url.replace(re, '$1' + key + "=" + val + '$2') : url + separator + key + "=" + val
    },

    /**
     * 隐藏/显示头部返回按钮
     * */
    hideBackBtn(hide = true) {
      try{ document.getElementsByClassName("btn-back")[0].style.display = hide ? 'none' : '' }catch (e) {
        try{ document.getElementsByClassName("back-btn")[0].style.display = hide ? 'none' : '' }catch (e) {
          console.log("隐藏/显示返回按钮失败", e)
        }
      }
    },

    /**
     * 判断移动端进入入口，隐藏头部返回按钮
     * */
    hideLevel1BackBtn(){
      let pageLevel = this.$route.query.page_level
      console.log('pageLevel', pageLevel)

      if(+pageLevel === 1) this.hideBackBtn()    // 从“我家”进入，隐藏返回按钮

      if(pageLevel) store.commit('setPageLevel', pageLevel)

      return pageLevel
    },

    /**
     * 从“我家”进入时隐藏头部
     * @Param {Array} lastPaths - 检查上一个页面是那些页面时隐藏头部返回按钮
     * */
    hideMyHomeInsidePageHead(param = {}) {

      let {showFrom, hideFrom} = param
      showFrom = showFrom || []         // 检查上一个页面是那些页面时 显示 头部返回按钮
      hideFrom = hideFrom || []         // 检查上一个页面是那些页面时 隐藏 头部返回按钮

      this.hideLevel1BackBtn()          // 有传level_page=1直接隐藏 并记录当前入口是否是从“我家”进入

      console.log('上一页地址', store.state.lastPath)

      let show = showFrom.includes(store.state.lastPath)
      let hide = hideFrom.includes(store.state.lastPath)
      if (store.getters.isFromMyHome && showFrom.length === 0 && hideFrom.length === 0){ hideBackBtn(); return }
      if (store.getters.isFromMyHome && show) return
      if (store.getters.isFromMyHome && hide) hideBackBtn()
    },

    /**
     * 得到当前入口 page_level (2-易家整配/其它入口、1-我家)
     * */
    getEntrance(){
      let pageLevel = this.$route.query.page_level
      if(pageLevel) pageLevel = typeof pageLevel === 'string' ? pageLevel : pageLevel[pageLevel.length-1]
      return +pageLevel
    },

    // --- 测试 ---

    /**
     * 清空用户活动、调研完成度、地址门牌号信息 (clearSurveyData)
     * */
    csd: async () => {
      let {data} = await clearUserData({})
      localStorage.clear()
      console.log('清除数据', data)
    },

    /**
     * 打开vConsole
     * */
    openVConsole(open = true, forceOpen){
      this.testConsole ++

      let openConsole = () => {
        if(open) {
          window.vConsole = new Vconsole()
          Vue.use(vConsole)
          localStorage.isTest = true
        }else {
          vConsole && vConsole.destroy()
          if(localStorage.isTest) delete localStorage.isTest
        }
      }

      if(this.testConsole == 20 || forceOpen){
        openConsole()
        this.testConsole = 0
      }

    },

    // --- ??? ---

    redirectToAuthPage: () => {
      const callbackURL = encodeURIComponent(appDomain + '')
      const state = encodeURIComponent('')
      const wechatId = 'wx7977941a06563864'
      const redirectURI = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wechatId}&redirect_uri=${callbackURL}&response_type=code&scope=snsapi_userinfo&state=${state}#wechat_redirect`
      window.location.href = redirectURI
    },

    openImage(list, index = 0) {
      const listNew = []
      list.forEach((item) => {
        listNew.push(item.indexOf(imgDomain) >= 0 ? item : (imgDomain + item))
      })

      // wx.previewImage({
      //   current: listNew[index], // 当前显示图片的http链接
      //   urls: listNew, // 需要预览的图片http链接列表
      // })
    },
    makePhoneCall(phoneNumber) {
      // wx.makePhoneCall({
      //   phoneNumber,
      // })
    },
    isPhone(val) {
      const phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      return phoneReg.test(val)
    },
    isIdcard(val) {
      const idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
      return idcardReg.test(val)
    },
    // isEmail(val) {
    //   const emailReg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/ ;
    //   return emailReg.test(val)
    // },
    isNull(val) {
      if (!val) return true;
      const nullReg = '^[ ]+$';
      const re = new RegExp(nullReg);
      return re.test(val);
    },
    isEmptyObject(val) {
      return JSON.stringify(val) === '{}'
    },
    getTwoDigits(num) {
      return num < 10 ? `0${num}` : num
    },
    getDateInterval(date, interval = 0) {
      const timestampNow = new Date().getTime();
      const timestamp = new Date(date.replace(/-/g, '/')).getTime();
      console.log(`timestampNow:${timestampNow}`, `timestamp:${timestamp}`)
      return timestampNow + interval > timestamp
    },
  },
}
